import modular from "modujs";
// import * as modules from "./_modules";
import "./_lazyload";
// import { setupAOS, setupIframes } from "./_animations";

// setupIframes();

const app = new modular({
    // modules: modules,
});

function adjustFooter() {
    const footer = document.getElementById('colophon');
    const windowHeight = window.innerHeight;
    const bodyHeight = document.querySelector('body').offsetHeight;
    
    // Calculer la position du footer en fonction de la hauteur de l'écran
    const footerHeight = footer.offsetHeight;
    const bottomPosition = windowHeight - footerHeight;
    console.log("window " + windowHeight);
    console.log("body " + bodyHeight);
    
    if (bodyHeight <= windowHeight) {
        // Appliquer la position calculée au footer
        footer.classList.add("footer-fixed");
    }
}

window.addEventListener('load', event => {
    const $style = document.getElementById("main-css");

    if ($style) {
        if ($style.isLoaded) {
            init();
        } else {
            $style.addEventListener("load", (event) => {
                init();
            });
        }
    } else {
        console.warn('The "main-css" stylesheet not found');
    }

    // Scroll to top button
    let mybutton = document.getElementById("scroll-top");
    window.onscroll = function() {scrollFunction()};
    mybutton.addEventListener("click", topFunction, true);
    function scrollFunction() {
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
            mybutton.classList.add("show");
        } else {
            mybutton.classList.remove("show");
        }
    }
    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    } 

    adjustFooter();
    
});

window.addEventListener('resize', adjustFooter);

function init() {
    app.init(app);
    document.documentElement.classList.add("is-loaded", "is-ready");
    document.documentElement.classList.remove("is-loading");
    
    // setupAOS();
}    
    
const langue = (navigator.language || navigator.userLanguage).split('-')[0];

// Textes disponibles
const traductions = {
  fr: {
    mobile: "Mobile : ",
    fixe: "Fixe : ",
    vcard: "Télécharger la vcard"
  },
  it: {
    mobile: "Cellulare : ",
    fixe: "Fisso : ",
    vcard: "Scarica la vcard"
  },
  en: {
    mobile: "Mobile: ",
    fixe: "Landline: ",
    vcard: "Download vcard"
  }
};

// Choisir la langue (par défaut anglais si non trouvé)
const t = traductions[langue] || traductions.en;

// Injecter la traduction pour "Mobile"
const elM = document.querySelector('.o-vcard__single-mobile .o-vcard__single-label');
if (elM) {
  elM.textContent = t.mobile; 
}

// Injecter la traduction pour "Mobile"
const elF = document.querySelector('.o-vcard__single-phone .o-vcard__single-label');
if (elF) {
  elF.textContent = t.fixe;
}


// Exemple si tu veux aussi injecter dans un bouton/lien "Télécharger la vcard"
const vcardBtn = document.querySelector('.o-vcard__single-top .VCARDHL-F8 a');
if (vcardBtn) {
  vcardBtn.textContent = t.vcard;
}

